module.exports = "../dist/frontend/icons/ui/categoryGlobus.svg?d50ce03279da652e96ac59b09739e06c";